import {Reducer} from 'redux';

import {EditorComponent, EditorPosition} from 'client/models/editor';
import {Template} from 'client/models/templates';

import types from './types';

type SystemPageTemplate = Template & {catalog_page_type?: string};

type state = {
  components: EditorComponent[];
  positions: EditorPosition[];
  objectResults: Record<number, Record<number, unknown>>;
  systemPagesTemplates: SystemPageTemplate[];
};

const initialState: state = {
  components: [],
  positions: [],
  objectResults: {},
  systemPagesTemplates: [],
};

const regionsReducer: Reducer<state> = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_EDITOR_COMPONENTS_SUCCESS:
      return {
        ...state,
        components: action.payload.editor_components,
      };

    case types.GET_POSITIONS_SUCCESS:
      return {
        ...state,
        positions: action.payload.editor_positions,
      };

    case types.GET_OPERATION_EDITOR_OBJECT_RESULT_SUCCESS:
      const {editorObjectId, positionId} = action.meta;
      const newObjectResults = {...state.objectResults};
      if (!newObjectResults[editorObjectId]) {
        newObjectResults[editorObjectId] = {};
      }
      newObjectResults[editorObjectId][positionId] = action.payload;
      return {
        ...state,
        objectResults: newObjectResults,
      };

    case types.GET_SYSTEM_PAGES_TEMPLATES_SUCCESS:
      return {
        ...state,
        systemPagesTemplates: action.payload.operation_templates || action.payload.master_templates || [],
      };

    default:
      return state;
  }
};

export default regionsReducer;
